<template>
  <div>
    <div class="about-banner txtC">
      <div class="about-container">
        <div class="slideshow">
          <VueSlickCarousel v-bind="settings" class="slider">
            <div class="item">
              <img src="~@/assets/images/sc-gallery-1.jpg" />
            </div>
            <div class="item">
              <img src="~@/assets/images/sc-gallery-2.jpg" />
            </div>
            <div class="item">
              <img src="~@/assets/images/sc-gallery-3.jpg" />
            </div>
          </VueSlickCarousel>
        </div>
        <div class="about-content">
          <h2>About SharedCharter</h2>
          <div class="text">
            <p>
              SharedCharter has managed to make the best way to fly
              <i>even better.</i> SharedCharter is a secure social hub for
              private air travelers. Here, you find other SharedCharter members
              headed in the same direction, at the same time. If they agree to
              share a flight, the cost is significantly reduced.
            </p>
          </div>
          <div class="down-arrow">
            <a href="#begin"><i class="fa fa-chevron-down"></i></a>
          </div>
        </div>
      </div>
    </div>

    <div id="begin" class="about-me">
      <div class="container-fliud">
        <div class="flex">
          <div class="image"></div>
          <div class="content">
            <h3>Carl Marbach</h3>
            <div class="text">
              <p>
                Founder and CEO Carl Marbach has been involved in aviation for
                more than 60 years. In 1996 He co-founded AVWeb, the Internet’s
                aviation magazine along with its emailed newsletter AVFlash.
              </p>
              <p>
                Throughout his career, Marbach has been a Commercial Pilot and
                owned seven airplanes, including one he built - a 2 seat Vans
                RV-7 experimental airplane.
              </p>
              <p>
                He has said, “There are a lot of empty seats flying every day. I
                know how convenient, how luxurious and how stress-free private
                flying can be. If we could only lower the cost and make it
                available to more people.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="charter-section">
      <div class="container">
        <div class="flex">
          <div class="images">
            <img src="~@/assets/images/super-star.png" />
          </div>
          <div class="content">
            <h3>SharedCharter</h3>
            <div class="text">
              <p>Share a charter flight and cut the cost by 50% or more.</p>
            </div>
            <div class="btn-wrap dark-blue-btn white-btn">
              <a href="#">Get started, search for your flight today!</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "About",
  metaInfo: {
            title: 'About Us | Shared Charter, Private Jet Travel',
            meta: [
                {
                    name: 'description',
                    content: 'Access private jet travel with help from Shared Charter! Learn about our company and how we offer shared private charter flights for less.'
                },
            ]
        },
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        draggable: true,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        fade: true,
        speed: 1500,
        infinite: true,
        cssEase: "ease-in-out",
        touchThreshold: 100,
      },
    };
  },
};
</script>

<style >
/* ABOUT ME */
html {
  scroll-behavior: smooth;
}
.about-me .flex {
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
}
.about-me .container-fliud {
  padding: 0 100px;
}
.about-me .image {
  width: 450px;
  line-height: 0;
  background: url("~@/assets/images/carl-marbach.jpg") no-repeat center / cover;
  min-height: 454px;
}
.about-me .content {
  width: calc(100% - 450px);
  padding: 105px 30px 105px 0;
}
.about-me .content .text p {
  max-width: 990px;
  margin-bottom: 12px;
}
.about-me .content h3 {
  color: #1a2d74;
  margin-bottom: 10px;
}

/* CHARTER SECTION */
.charter-section {
  background-image: url("~@/assets/images/why-sc-bg.jpg");
  background-repeat: no-repeat;
  background-position: center bottom;
  background-attachment: fixed;
  background-size: cover;
  position: relative;
  z-index: 1;
  padding: 57px 0;
}
.charter-section:after {
  position: absolute;
  content: "";
  background: rgba(26, 45, 116, 0.66);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
}
.charter-section .container {
  padding: 0 60px;
}
.charter-section .flex {
  display: flex;
}
.charter-section .images {
  width: 300px;
  line-height: 0;
  margin-right: 50px;
}
.charter-section h3 {
  margin-top: 20px;
  color: #fff;
}
.charter-section .text p {
  margin: 10px 0 80px;
  color: #fff;
}
.about-banner {
  min-height: 900px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.about-banner:after {
  position: absolute;
  content: "";
  background: rgba(26, 45, 116, 0.66);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
.about-banner .about-container {
  width: 100%;
}
.about-banner .about-content {
  position: relative;
  z-index: 1;
  padding: 0 30px;
}
.about-banner .about-content .text p {
  margin: 40px 0 60px;
  color: #fff;
}
.about-banner .about-content .text {
  max-width: 1060px;
  margin: 0 auto;
}
.about-banner .about-content h2 {
  font-size: 42px;
  color: #fff;
}
.about-banner .about-content .down-arrow a {
  color: #fff;
}
.about-banner .slideshow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.about-banner .slideshow .slider-track {
  -webkit-transition: all 5s cubic-bezier(0.7, 0, 0.3, 1);
  transition: all 5s cubic-bezier(0.7, 0, 0.3, 1);
}
.about-banner .slideshow .item {
  height: 100%;
  position: relative;
  z-index: 1;
}
.about-banner .slideshow .slick-slide img {
  width: 100%;
  -webkit-transition: all 5s cubic-bezier(0.7, 0, 0.3, 1);
  transition: all 5s cubic-bezier(0.7, 0, 0.3, 1);
  -webkit-transform: scale(1.3);
  transform: scale(1.3);
}
.about-banner .slideshow .slick-slide.slick-active img {
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-animation: cssAnimation 8s 1 ease-in-out forwards;
  animation: cssAnimation 8s 1 ease-in-out forwards;
}
@keyframes {
  from {
    -webkit-transform: scale(1) translate(0px);
  }
  to {
    -webkit-transform: scale(1.3) translate(0px);
  }
}
@-webkit-keyframes cssAnimation {
  from {
    -webkit-transform: scale(1) translate(0px);
  }
  to {
    -webkit-transform: scale(1.3) translate(0px);
  }
}

@media (max-width: 1619px) {
  .about-me .content {
    padding: 80px 30px 80px 0;
  }
}
@media (max-width: 1429px) {
  .about-me .container-fliud {
    padding: 0 50px;
  }
}
@media (max-width: 1200px) {
  .about-banner {
    min-height: 670px;
  }
}
@media (max-width: 991px) {
  .about-me .flex {
    display: block;
  }
  .about-me .container-fliud {
    padding: 60px 15px;
  }
  .about-me .content {
    padding: 40px 0 0;
    width: 100%;
  }
  .about-banner {
    min-height: 500px;
  }
  .about-banner .about-content h2 {
    font-size: 36px;
  }
  .about-banner .about-content .text p {
    margin: 30px 0;
  }

  .charter-section .container {
    padding: 0 15px;
  }
  .charter-section .text p {
    margin-bottom: 40px;
  }
}
@media (max-width: 767px) {
  .about-banner .about-content {
    padding: 30px;
  }
  .about-banner .slideshow {
    position: inherit;
  }
  .about-banner .about-content h2 {
    font-size: 30px;
  }
  .about-banner .about-content .text p {
    margin: 20px 0;
  }

  .charter-section .flex {
    display: block;
    text-align: center;
  }
  .charter-section .images {
    margin: 0 auto;
  }
}
@media (max-width: 575px) {
  .about-me .image {
    width: 100%;
  }
}
</style>